import { request } from '@@/plugin-request';

export async function getTeamMembers(params) {
  return request('/api/team/operation/members', {
    method: 'GET',
    params,
  });
}

export async function getOwnOperationData({ startAt, endAt }) {
  return request('/api/team/myOperation', {
    method: 'GET',
    params: { startAt, endAt },
  });
}

export async function getTeamMembersLessons(data) {
  return request('/api/team/operation/members/lessons', {
    method: 'POST',
    data,
  });
}
